import { QueryClient } from '@tanstack/react-query';
export const queryClient = new QueryClient();
//# sourceMappingURL=queryClient.js.map